import { render, staticRenderFns } from "./Old - RekapNotaPerKapal.vue?vue&type=template&id=4619f51c&scoped=true&"
import script from "./Old - RekapNotaPerKapal.vue?vue&type=script&lang=js&"
export * from "./Old - RekapNotaPerKapal.vue?vue&type=script&lang=js&"
import style0 from "./Old - RekapNotaPerKapal.vue?vue&type=style&index=0&id=4619f51c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4619f51c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow,VTextField})
